// @flow
import styled from 'styled-components';
import {
  textNormal,
  textBlack,
  textBold,
  textBoldLoose,
  textSemiBold,
} from './css';
import { Text6 } from './Text';

export const Text6Normal = styled(Text6)`
  ${textNormal};
`;

export const Text6Black = styled(Text6)`
  ${textBlack};
`;

export const Text6Bold = styled(Text6)`
  ${textBold};
`;

export const Text6SemiBold = styled(Text6)`
  ${textSemiBold};
`;

export const Text6BoldLoose = styled(Text6)`
  ${textBoldLoose};
`;
